module.exports = __webpack_public_path__ + "img/background-document-detail.bbb24e2d.svg";